var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, OnDestroy } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { ShowColumn } from '../../state/view.actions';
import { NextChapter, PreviousChapter } from 'src/app/story/state/chapters/story.chapters.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject } from 'rxjs';
import { StoryType } from 'src/app/story/models/story-type.enum';
import { BookmarkActionsEnum } from 'src/app/bookmarks/components/bookmark-actions/bookmark-actions.component';
import { BookmarksState } from 'src/app/bookmarks/state/bookmarks.state';
import { takeUntil, filter } from 'rxjs/operators';
import { StoryState } from 'src/app/story/state/story.state';
import * as _ from 'lodash';
import { AnimationService } from 'src/app/engine/animation.service';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
var PanelComponent = /** @class */ (function () {
    function PanelComponent(store, animationService) {
        this.store = store;
        this.animationService = animationService;
        this.category = '';
        this.collapsed = false;
        this.isAnimated = false;
        this.showScrubber = false;
        this.showPlayPause = false;
        this.chapterCount = 1;
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(PanelComponent.prototype, "bookmarkActions", {
        get: function () {
            var organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
            return __spread([
                BookmarkActionsEnum.CopyLink,
                BookmarkActionsEnum.Embed,
                BookmarkActionsEnum.CopyBookmark
            ], organization ? [BookmarkActionsEnum.CopyTeamBookmark] : []);
        },
        enumerable: true,
        configurable: true
    });
    PanelComponent.prototype.ngOnInit = function () {
        this.initListeners();
    };
    PanelComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    PanelComponent.prototype.initListeners = function () {
        var _this = this;
        // Handle story loaded
        this.story$
            .pipe(filter(function (story) { return story != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (story) { return _this.handleStoryLoaded(story); });
        // Handle chapter loaded
        this.selectedChapter$.pipe(filter(function (chapter) { return chapter != null; }), takeUntil(this.ngUnsubscribe)).subscribe(function (chapter) {
            _this.handleChapterReady(chapter);
        });
        this.chapters$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (chapters) { return _this.chapterCount = chapters.length; });
    };
    PanelComponent.prototype.handleNextClick = function () {
        this.store.dispatch(new NextChapter());
    };
    PanelComponent.prototype.handlePreviousClick = function () {
        this.store.dispatch(new PreviousChapter());
    };
    PanelComponent.prototype.handleCloseClick = function () {
        this.store.dispatch(new ShowColumn(false));
    };
    PanelComponent.prototype.handleStoryLoaded = function (story) {
        this.showScrubber = _.get(story, 'ui.scrubber') === true;
        this.showPlayPause = _.get(story, 'ui.playPause') === true;
    };
    PanelComponent.prototype.handleChapterReady = function (chapter) {
        this.isAnimated = this.animationService.isChapterAnimated(chapter);
    };
    PanelComponent.prototype.showPanelFooter = function () {
        if (this.isAnimated && (this.showPlayPause || this.showScrubber)) {
            return true;
        }
        if (this.chapterCount > 1) {
            return true;
        }
        return false;
    };
    __decorate([
        Select(StoryState.getStory),
        __metadata("design:type", Observable)
    ], PanelComponent.prototype, "story$", void 0);
    __decorate([
        Select(BookmarksState.getSelectedBookmark),
        __metadata("design:type", Observable)
    ], PanelComponent.prototype, "bookmark$", void 0);
    __decorate([
        Select(StoryChaptersState.getStoryChapters),
        __metadata("design:type", Observable)
    ], PanelComponent.prototype, "chapters$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], PanelComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterIndex),
        __metadata("design:type", Observable)
    ], PanelComponent.prototype, "selectedChapterIndex$", void 0);
    __decorate([
        Select(StoryChaptersState.getChaptersLoaded),
        __metadata("design:type", Observable)
    ], PanelComponent.prototype, "chaptersLoaded$", void 0);
    __decorate([
        Select(StoryChaptersState.getAllChaptersReady),
        __metadata("design:type", Observable)
    ], PanelComponent.prototype, "allChaptersReady$", void 0);
    return PanelComponent;
}());
export { PanelComponent };
